__turbopack_export_value__({
  "accessibility": "ContactsGrid-module-scss-module__QDFHIW__accessibility",
  "body-logo-18": "ContactsGrid-module-scss-module__QDFHIW__body-logo-18",
  "body-text-12": "ContactsGrid-module-scss-module__QDFHIW__body-text-12",
  "body-text-14": "ContactsGrid-module-scss-module__QDFHIW__body-text-14",
  "body-text-16": "ContactsGrid-module-scss-module__QDFHIW__body-text-16",
  "body-text-18": "ContactsGrid-module-scss-module__QDFHIW__body-text-18",
  "body-text-20": "ContactsGrid-module-scss-module__QDFHIW__body-text-20",
  "body-text-24": "ContactsGrid-module-scss-module__QDFHIW__body-text-24",
  "body-text-24-2": "ContactsGrid-module-scss-module__QDFHIW__body-text-24-2",
  "body-text-heading-2": "ContactsGrid-module-scss-module__QDFHIW__body-text-heading-2",
  "body-text-heading-3": "ContactsGrid-module-scss-module__QDFHIW__body-text-heading-3",
  "body-text-medium-14": "ContactsGrid-module-scss-module__QDFHIW__body-text-medium-14",
  "body-text-medium-16": "ContactsGrid-module-scss-module__QDFHIW__body-text-medium-16",
  "body-text-medium-18": "ContactsGrid-module-scss-module__QDFHIW__body-text-medium-18",
  "body-text-medium2-18": "ContactsGrid-module-scss-module__QDFHIW__body-text-medium2-18",
  "body-text2-14": "ContactsGrid-module-scss-module__QDFHIW__body-text2-14",
  "body-text2-16": "ContactsGrid-module-scss-module__QDFHIW__body-text2-16",
  "button-primary-text": "ContactsGrid-module-scss-module__QDFHIW__button-primary-text",
  "button-text": "ContactsGrid-module-scss-module__QDFHIW__button-text",
  "button2-text": "ContactsGrid-module-scss-module__QDFHIW__button2-text",
  "card-shadow": "ContactsGrid-module-scss-module__QDFHIW__card-shadow",
  "contactsCard": "ContactsGrid-module-scss-module__QDFHIW__contactsCard",
  "contactsCard__address": "ContactsGrid-module-scss-module__QDFHIW__contactsCard__address",
  "contactsCard__email": "ContactsGrid-module-scss-module__QDFHIW__contactsCard__email",
  "contactsCard__emails": "ContactsGrid-module-scss-module__QDFHIW__contactsCard__emails",
  "contactsCard__phone": "ContactsGrid-module-scss-module__QDFHIW__contactsCard__phone",
  "contactsCard__phones": "ContactsGrid-module-scss-module__QDFHIW__contactsCard__phones",
  "contactsCard__svgWrapper": "ContactsGrid-module-scss-module__QDFHIW__contactsCard__svgWrapper",
  "effect-menu": "ContactsGrid-module-scss-module__QDFHIW__effect-menu",
  "grid": "ContactsGrid-module-scss-module__QDFHIW__grid",
  "grid__card": "ContactsGrid-module-scss-module__QDFHIW__grid__card",
  "grid__card_accessibility": "ContactsGrid-module-scss-module__QDFHIW__grid__card_accessibility",
  "grid__card_mobileAccessibility": "ContactsGrid-module-scss-module__QDFHIW__grid__card_mobileAccessibility",
  "grid__column": "ContactsGrid-module-scss-module__QDFHIW__grid__column",
  "grid__column_schedule": "ContactsGrid-module-scss-module__QDFHIW__grid__column_schedule",
  "header-1": "ContactsGrid-module-scss-module__QDFHIW__header-1",
  "line": "ContactsGrid-module-scss-module__QDFHIW__line",
  "main-container": "ContactsGrid-module-scss-module__QDFHIW__main-container",
  "main-footer-container": "ContactsGrid-module-scss-module__QDFHIW__main-footer-container",
  "main-header-container": "ContactsGrid-module-scss-module__QDFHIW__main-header-container",
  "mainPhone": "ContactsGrid-module-scss-module__QDFHIW__mainPhone",
  "second": "ContactsGrid-module-scss-module__QDFHIW__second",
  "txt-12-bold": "ContactsGrid-module-scss-module__QDFHIW__txt-12-bold",
  "txt-14-bold": "ContactsGrid-module-scss-module__QDFHIW__txt-14-bold",
  "txt-14-bold-caps": "ContactsGrid-module-scss-module__QDFHIW__txt-14-bold-caps",
  "txt-14-med": "ContactsGrid-module-scss-module__QDFHIW__txt-14-med",
  "txt-16-bold": "ContactsGrid-module-scss-module__QDFHIW__txt-16-bold",
  "txt-16-med": "ContactsGrid-module-scss-module__QDFHIW__txt-16-med",
  "txt-18-bold": "ContactsGrid-module-scss-module__QDFHIW__txt-18-bold",
  "txt-18-medium": "ContactsGrid-module-scss-module__QDFHIW__txt-18-medium",
  "txt-18-medium-24": "ContactsGrid-module-scss-module__QDFHIW__txt-18-medium-24",
  "txt-24-semi": "ContactsGrid-module-scss-module__QDFHIW__txt-24-semi",
  "wrapper": "ContactsGrid-module-scss-module__QDFHIW__wrapper",
});
